import { useEffect, useState } from 'react';
import { useAbilityReady } from './abilityContext';

/**
 * How long to wait for the user's roles to replicate before giving up and
 * deciding on what we have. Without a bound, a user whose UserProfile never
 * arrives would wait for ever.
 */
export const ROLES_WAIT_MS = 8000;

/**
 * Whether a decision that hangs on the user's ROLES may be taken yet — the
 * roles have replicated, or the wait above has run out.
 *
 * Until the profiles land, everyone looks role-less ({@link useAbilityReady}),
 * and a routing decision taken in that moment is wrong for exactly the people
 * it matters for: office staff would be sent to the field app on a cold first
 * login. So both ends of the office/field split wait through this hook, and
 * therefore wait the SAME way.
 */
export function useRolesSettled(): boolean {
    const rolesReady = useAbilityReady();
    const [waitedLongEnough, setWaitedLongEnough] = useState(false);

    useEffect(() => {
        const timer = setTimeout(
            () => setWaitedLongEnough(true),
            ROLES_WAIT_MS
        );
        return () => clearTimeout(timer);
    }, []);

    return rolesReady || waitedLongEnough;
}
